
    <fieldmagic-primary-button
      variant="link"
      purpose="widget-action"
      label="link_checklist"
      icon="link"
      (click)="showDialog()"
    >
    </fieldmagic-primary-button>
  